import HeaderMenuContainer from './HeaderMenuContainer';

export default HeaderMenuContainer;
